/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TabContext, TabPanel } from '@material-ui/lab';
import { Button, Tab, Tabs } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { COLUMN, OPTIONS, createVerificationRequestCar } from './utils';
import { CarsClient, Verification } from '../../services/api';
import { ShifterImages } from 'components/ParcelDetail/ShifterImages';
import DialogComponent from 'components/UserDetail/DialogComponent';
import { getVerificationStatusText } from 'models/util';

const VerificationCarRequestDetail = function (): JSX.Element {

  enum vfStatus {
    notVerified = 'NotVerified',
    pending = 'VerificationPending',
    verified = 'Verified',
    failure = 'VerificationFailure'
  }

  const { t } = useTranslation();

  const title = t('detail_verification');
  const { id } = useParams();
  const { getVerificationCarById, changeVerificationCarById } = Verification();
  const { getCarById } = CarsClient();
  const [data, setData] = useState<any[]>([]);
  const [tabValue, setTabValue] = React.useState<string>('1');
  const [images, setImages] = useState([]);
  const [isVisable, setIsVisable] = useState(false);
  const [comment, setComment] = useState<string>('');
  const [language, setLanguage] = useState<string>('ru');
  const [pasportPhotos, setPasportPhotos] = useState([]);
  const handleTabChange = (event: any, newValue: string) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    (async () => {
      const verificationCarById = await getVerificationCarById(id);
      verificationCarById.verificationStatus = t(getVerificationStatusText(verificationCarById.verificationStatus));
      const car = await getCarById(verificationCarById.carId)
      const detail = createVerificationRequestCar(verificationCarById, car, t);
      setPasportPhotos(verificationCarById.carPassportPhotoUrls);
      setImages(verificationCarById.imageUrls);
      setLanguage(verificationCarById.language);
      setData(detail);
    })();
  }, [t, id]);

  const changeConfirm = async (value: boolean, status: string) => {
    const data = {
      isReviewed: value,
      comment: comment,
      verificationStatus: status
    }
    await changeVerificationCarById(id, data);
    setComment('');
    setIsVisable(false);
    window.location.reload();
  }

  return (
    <React.Fragment>
      <h1 style={{ textAlign: 'center' }}>{title}</h1>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: '20px' }}>
        <div style={{ width: '40%', marginRight: '2%' }}>
          <MUIDataTable
            title={''}
            data={data.slice(0, 9)}
            columns={COLUMN(t)}
            options={OPTIONS(t)}
          />
        </div>

      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <div style={{ margin: '5px' }}>
          <Button variant='outlined' style={{backgroundColor:'#008000'}} onClick={() => { changeConfirm(true, vfStatus.verified) }} >
            {t('confirm')}
          </Button>
        </div>
        <div style={{ margin: '5px' }}>
          <Button variant='outlined' style={{backgroundColor:'#c70000'}} onClick={() => { setIsVisable(true) }}>
            {t('no_confirm')}
          </Button>
        </div>
      </div>
      <DialogComponent
        open={isVisable}
        handleClose={() => {
          setIsVisable(false);
        }}
        reason={comment}
        title={t('reason')}
        setReason={setComment}
        add={()=>changeConfirm(false, vfStatus.failure)}
        language={language}
      />
      <div style={{ width: '100%', margin: '30px' }}>
        <TabContext value={tabValue}>
          <Tabs value={tabValue} onChange={handleTabChange} textColor='primary' indicatorColor='primary'>
            <Tab value='1' label={`${t('photo_inspection')}`} />
            <Tab value='2' label={`${t('car_photo')}`} />
          </Tabs>

          <TabPanel value='1'>
            <ShifterImages list={pasportPhotos} />
          </TabPanel>
          <TabPanel value='2'>
            <ShifterImages list={images} />
          </TabPanel>
        </TabContext>
      </div>
    </React.Fragment>
  );
};

export default VerificationCarRequestDetail;
